{
  "commerce": {
    "aiChatView": {
      "errorPausedDetail": "L’IA è inclusa con un abbonamento attivo: apri Impostazioni → Fatturazione per abbonarti."
    },
    "billingPage": {
      "title": "Fatturazione"
    },
    "paywallGate": {
      "errorOpenBilling": "Impossibile aprire la pagina di fatturazione. Riprova.",
      "lapsedDescription": "Rinnova l’abbonamento per continuare a gestire la tua struttura: 30 € per unità al mese, IA inclusa.",
      "pastDue": "Pagamento non riuscito. Aggiorna il metodo di pagamento per mantenere l’accesso.",
      "startTrial": "Inizia la prova gratuita di {days} giorni",
      "subscribe": "Abbonati",
      "subscribeDescription": "Hai già usato la prova gratuita. Abbonati per continuare a gestire la tua struttura: 30 € per unità al mese, IA inclusa.",
      "subscribeTitle": "Abbonati a Vidimo",
      "trialAddPaymentMethod": "Aggiungi un metodo di pagamento per mantenere l’accesso.",
      "trialDescription": "Prova Vidimo gratis per {days} giorni, senza carta di credito. Poi 30 € per unità al mese, IA inclusa.",
      "trialTitle": "Inizia la prova gratuita"
    },
    "propertySettingsView": {
      "billingDescription": "Abbonamento, utilizzo dell’IA e metodo di pagamento",
      "billingTitle": "Fatturazione"
    },
    "subscriptionGate": {
      "aiIncluded": "Le funzioni IA sono incluse nel tuo piano.",
      "aiTitle": "IA",
      "errorGeneric": "Si è verificato un errore",
      "errorLoad": "Impossibile caricare i dati di fatturazione",
      "manageSubscription": "Gestisci abbonamento",
      "status": {
        "active": "Attivo",
        "past_due": "Pagamento in ritardo",
        "trialing": "Prova gratuita"
      },
      "subscribe": "Abbonati",
      "subscribePrice": "30 € per unità al mese, fatturati in base al numero di unità di questa struttura. Funzioni IA incluse.",
      "subscribeTitle": "Abbonati",
      "subscribedPrice": "30 € per unità al mese. Se aggiungi o rimuovi un’unità, l’importo si aggiorna automaticamente.",
      "subscriptionTitle": "Abbonamento"
    }
  }
}
